import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const totalDeltaGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX_Total_Delta',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX_Total_Delta@tv-basicstudies-1",
        description: "SPX Total Delta",
        shortDescription: "SPX Total Delta",
        linkedToSeries: true,
        is_price_study: false,
        format: { type: "price" },
        plots: [
          {
            id: "net_delta",
            type: "line",
            title: "Net Delta",
            trackPrice: true,
            transparency: 70,
            fillGaps: true
          },
          {
            id: "zero_line",
            type: "line",
            title: "Zero Line"
          }
        ],
        defaults: {
          styles: {
            net_delta: {
              linestyle: 0,
              linewidth: 1,
              plottype: 8,
              trackPrice: false,
              transparency: 60,
              visible: true,
              color: "#d90d79",
              color2: "#FF4500",
            },
            zero_line: {
              linestyle: 0,
              linewidth: 1,
              color: "#ffffff",
              visible: true
            }
          },
          precision: 2,
          inputs: {}
        },
        styles: {
          net_delta: { title: "Net Delta", histogramBase: 0 },
          zero_line: { title: "Zero Line" }
        },
        inputs: []
      },
      constructor: function () {
        this._debugMode = true;

        this.init = function (ctx) {
          this._context = ctx;
        };

        this.main = function (ctx) {
          try {
            const { greekExposures } = useGreeksWebsocketDataStore.getState();
            const spxExposures = greekExposures.spx;

            if (!spxExposures?.length) {
              if (this._debugMode) {
                // console.log('[totalDeltaGetter] No greek exposures data');
              }
              return [null, null];
            }

            const time = ctx.symbol.time;
            if (!time || isNaN(time)) {
              if (this._debugMode) {
                // console.log('[totalDeltaGetter] Invalid symbol time:', time);
              }
              return [null, null];
            }

            const timeInSec = Math.floor(time / 1000);

            const deltaExposures = spxExposures
              .filter(exp => exp.greek_type === 'delta')
              .sort((a, b) => a.timestamp - b.timestamp);

            if (!deltaExposures.length) {
              return [null, null];
            }

            let closestExp = deltaExposures[0];
            let minDiff = Math.abs(closestExp.timestamp - timeInSec);

            for (const exp of deltaExposures) {

              const diff = Math.abs(exp.timestamp - timeInSec);

              if (diff < minDiff) {
                minDiff = diff;
                closestExp = exp;
              }
            }

            const value = parseFloat(closestExp.net_exposure) || 0;

            return [value, 0];  // Return both the delta value and zero line
          } catch (err) {
            return [null, null];
          }
        };

        this.destroy = function() {
          // No cleanup needed since we're not using subscriptions
        };
      }
    }
  ]);
};